import React, { useMemo } from 'react';
import { Button } from '@pinwheel/origami';
import useLinkNavigate from '../hooks/useLinkNavigate';
import { selectFeatureFlags, selectLinkTokenPayload, } from '../state/slices/slice-link-params';
import { useAppSelector } from '../state';
import { useGetLocalizedString } from '../hooks/useGetLocalizedString';
function ReturnToSearchButton() {
    var navigate = useLinkNavigate();
    var getLocalizedString = useGetLocalizedString();
    var featureFlags = useAppSelector(selectFeatureFlags);
    var _a = useAppSelector(selectLinkTokenPayload), accountId = _a.accountId, employerId = _a.employerId, platformId = _a.platformId, platformKey = _a.platformKey;
    var returnToSearchText = useMemo(function () {
        return getLocalizedString('RETURN_TO_SEARCH');
    }, [getLocalizedString]);
    if (featureFlags.hideReturnToSearchButton || accountId)
        return null;
    /**
     * https://pinwheel.atlassian.net/browse/CORE-1643
     * Display the return to search button only
     * if platformId or employerId or platformKey are NOT NULL
     */
    if (employerId || platformId || platformKey)
        return (React.createElement(Button, { variant: "outline", "data-testid": "ReturnToSearchButton", onClick: function () { return navigate('/search/search'); } }, returnToSearchText));
    return null;
}
export default ReturnToSearchButton;
